import { Backdrop, CircularProgress } from '@mui/material'
import React, { FC } from 'react'

type Props = {
    open?: boolean
    keycloak?: boolean
}

const LoadingOverlay: FC<Props> = ({ open = false, keycloak = false }) => (
    <Backdrop
        aria-hidden={false}
        open={open}
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
        <CircularProgress color="inherit" />
    </Backdrop>
)

export { LoadingOverlay }